module.exports = __webpack_public_path__ + "img/qy4@2x.d30cb93e.png";